import { makeStyles, Theme, createStyles } from '@material-ui/core'
import colors from '../../styles/colors'

/** Altura efetiva do header fixo (padding 10+10 em volta do avatar de 40px). */
const HEADER_HEIGHT = 61

export const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    /* O documento inteiro é uma coluna flex de altura de viewport. Sem isso,
       TODA página do app rolava um pouquinho e nunca parava de rolar:
       `contentContainer` pedia `100vh - HEADER` de altura mínima e o `<Footer>`
       vinha DEPOIS dele, fora — então o documento media, por construção,
       `100vh + altura do rodapé`. O resultado era a faixa morta no fim de
       qualquer tela, mesmo vazia. Agora o rodapé entra no mesmo orçamento de
       100vh: página curta não rola, e página longa rola pelo conteúdo. */
    container: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      width: '100%',
      /* O deslocamento do header saiu do `marginTop` do main e virou padding
         daqui. O header é `position: fixed` (header/styles/index.styles.ts:15),
         então está fora do fluxo e alguém precisa reservar a faixa dele — mas
         reservar por margem no filho deixava a margem FORA da conta de 100vh,
         que é metade da razão do scroll fantasma. */
      paddingTop: HEADER_HEIGHT,
      backgroundColor: colors.grayLight,
    },
    contentContainer: {
      position: 'relative',
      /* Cresce para ocupar o que sobra entre header e rodapé, e nada além. É o
         que dá à tela da Entrevista uma altura REAL para dividir entre a
         conversa e o painel, em vez do `68vh` chutado que ela usava. */
      flex: '1 0 auto',
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
      transition: 'margin .25s ease',
    },

    /* MODO QUADRO — opt-in, hoje só a Entrevista.

       A diferença com o modo normal é `height` em vez de `minHeight`: aqui a
       altura é DEFINIDA, e é isso que permite a um filho dizer `flex: 1` e
       realmente parar de crescer. No modo normal `contentContainer` é
       `flex: 1 0 auto` — cresce com o conteúdo e nunca trava, que é o certo
       para um formulário longo e o errado para uma bancada de trabalho: numa
       viewport de 900px a Entrevista media 1998px de documento, e o painel
       lateral, sem teto, nunca rolava por dentro.

       O rodapé não é renderizado neste modo. Ele é bloco de marca — logo,
       política de privacidade, versões, redes — e faz sentido no fim de uma
       página que se percorre. Numa tela que É uma bancada, ele só existiria
       para produzir a faixa de scroll que esta entrega foi feita para matar. */
    containerFrame: {
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      width: '100%',
      overflow: 'hidden',
      paddingTop: HEADER_HEIGHT,
      backgroundColor: colors.grayLight,
    },
    contentFrame: {
      position: 'relative',
      /* `1 1 0` e não `1 0 auto`: a base zero é o que faz a altura vir do
         container em vez de vir do conteúdo. Com `minHeight: 0` os
         descendentes podem encolher abaixo do próprio conteúdo — sem isso,
         `overflow: auto` num neto não tem efeito nenhum. */
      flex: '1 1 0',
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      transition: 'margin .25s ease',
    },
  }),
)
